export const NOTIFICATION_TYPES = {
  REPORT_READY: "report_ready",
  PLAN_UPGRADED: "plan_upgraded",
  PLAN_DOWNGRADED: "plan_downgraded",
  PAYMENT_FAILED: "payment_failed",
  /** Challenge validé : la prop firm a clôturé le compte d'évaluation. */
  ACCOUNT_CHALLENGE_COMPLETED: "account_challenge_completed",
  /** Compte disparu côté broker sans signal de réussite. */
  ACCOUNT_CLOSED_BROKER: "account_closed_broker",
  /** Règle de drawdown violée : le compte est désactivé par la sync.
   *  UNE notification PAR COMPTE, et non une groupée par cycle : chaque
   *  notification porte le lien vers SON compte, et un breach est l'événement
   *  le plus lourd du cycle de vie d'un compte prop firm — il doit être nommé.
   *  Distinct de ACCOUNT_CLOSED_BROKER : ici le compte existe toujours chez le
   *  broker, c'est Edgely qui constate la violation. */
  ACCOUNT_DRAWDOWN_BREACH: "account_drawdown_breach",
  /** Payout détecté par la sync (invariant de solde ou cash log) et écrit
   *  d'office sur un compte funded. Une par payout : elle porte le montant,
   *  seul moyen pour l'utilisateur de repérer une détection erronée. */
  PAYOUT_DETECTED: "payout_detected",
  /** Sortie d'argent égale au net d'UNE séance récente sur un compte funded :
   *  la firm a repris le profit (infraction MAE Apex legacy), ce n'est pas un
   *  payout (propFirmClawback.ts). Porte le montant et la séance, pour que
   *  l'utilisateur requalifie en payout si c'en était un. */
  PROP_FIRM_ADJUSTMENT_DETECTED: "prop_firm_adjustment_detected",
  /** Sortie d'argent détectée sur un compte d'une prop firm à wallet (TPT) :
   *  transfert vers le wallet, pas un payout (walletPayoutRouting.ts). Porte le
   *  brut, le net estimé et `toConfirm` quand le net reste à confirmer. */
  WALLET_TRANSFER_DETECTED: "wallet_transfer_detected",
  /** Un ou plusieurs comptes neufs vus côté broker lors d'un cycle de sync.
   *  Groupée par cycle et non par compte : une prop firm qui délivre un lot
   *  produit une seule ligne, pour une seule action d'import. */
  TRADOVATE_ACCOUNTS_DISCOVERED: "tradovate_accounts_discovered",
  /** Le flux temps reel (socket) d'une connexion est interrompu depuis plus
   *  d'une heure. Une seule par episode ; la sync REST continue toutes les
   *  15 min, donc l'utilisateur ne perd rien, il perd seulement l'instantane. */
  TRADOVATE_REALTIME_INTERRUPTED: "tradovate_realtime_interrupted",
  /** Une connexion est passee en `needs_reauth` : la sync est en pause tant
   *  que l'utilisateur ne refait pas l'OAuth. Une seule par interruption,
   *  emise avec l'email sur la meme transition (tradovateReauthTransition.ts). */
  TRADOVATE_NEEDS_REAUTH: "tradovate_needs_reauth",
  /** Challenge en abonnement cramé : la prop firm continue de prélever tant
   *  que l'utilisateur n'a pas résilié, et remet le compte à zéro au
   *  renouvellement. Une par abonnement (verrou `cancelAskedAt`). */
  SUBSCRIPTION_CANCEL_QUESTION: "subscription_cancel_question",
  /** Prélèvement récurrent dans 3 jours (job chargeReminders). Une par
   *  échéance (verrou `reminderSentAt`). */
  CHARGE_UPCOMING: "charge_upcoming",
  /** Abonnement gardé après un cramage : le prélèvement du jour a dû remettre
   *  le compte à zéro. Hors Tradovate (sa sync détecte le reset seule). */
  SUBSCRIPTION_RESET_REACTIVATE: "subscription_reset_reactivate",
} as const;

export type NotificationType =
  (typeof NOTIFICATION_TYPES)[keyof typeof NOTIFICATION_TYPES];

/** Prefixes de source. La cloche fusionne deux tables tant que les ecritures
 *  mentor ne sont pas repliees : l'id expose porte donc sa provenance, pour que
 *  le marquage « lu » sache quelle table mettre a jour. */
export const SOURCE_PREFIX = {
  NOTIFICATION: "notif:",
  MENTOR: "mentor:",
} as const;

/** Forme exposee au client, commune aux deux sources. */
export interface NotificationDto {
  /** Id prefixe : "notif:<uuid>" ou "mentor:<uuid>". */
  id: string;
  type: string;
  link: string | null;
  metadata: Record<string, unknown> | null;
  isRead: boolean;
  createdAt: string; // ISO
}
